import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Button, Input, Select } from 'antd';
import { onKeyDown } from '../../hooks';
import { sendToAmplitude } from '../../model';
import s from './index.module.css';

const { Option } = Select;
const optionsList = [
    'Online Search',
    'Social Media',
    'Email Marketing',
    'Referral',
    'Industry Event',
    'Webinar or Workshop',
    'Advertising',
    'Press Release/Media',
    'Sales Team',
    'Partner Referral',
    'Blog or Publication',
    'Other'
];

type PersonalProps = {
    prev: () => void;
    onSubmit: () => void;
};

export const PersonalData: FC<PersonalProps> = ({ prev, onSubmit }) => {
    const {
        control,
        formState: { errors }
    } = useFormContext();
    const disabled = !!errors.firstname || !!errors.lastname || !!errors.find;

    return (
        <>
            <Controller
                name='firstname'
                control={control}
                rules={{ required: 'Please complete this required field' }}
                render={({ field }) => (
                    <Input
                        {...field}
                        size='large'
                        placeholder='First name'
                        onKeyDown={e => onKeyDown(e, onSubmit)}
                        onFocus={() => sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_FIRST_NAME`)}
                    />
                )}
            />

            <Controller
                name='lastname'
                control={control}
                rules={{ required: 'Please complete this required field' }}
                render={({ field }) => (
                    <Input
                        {...field}
                        size='large'
                        placeholder='Last name'
                        onKeyDown={e => onKeyDown(e, onSubmit)}
                        onFocus={() => sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_LAST_NAME`)}
                    />
                )}
            />

            <Controller
                name='how_find_us'
                control={control}
                rules={{ required: 'Please complete this required field' }}
                render={({ field }) => (
                    <Select
                        {...field}
                        placeholder='How did you hear about us?'
                        size='large'
                        onFocus={() => sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_HOW_FIND`)}
                        onKeyDown={e => onKeyDown(e, onSubmit)}
                    >
                        {optionsList.map(option => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                )}
            />

            {errors.email && <p className={s.error}>{errors.email.message as string}</p>}

            <div className={s.actions}>
                {errors.email && (
                    <Button size='large' onClick={prev}>
                        Back
                    </Button>
                )}
                <Button
                    type='primary'
                    htmlType='submit'
                    block={!errors.email}
                    size='large'
                    disabled={disabled}
                >
                    Complete sign up
                </Button>
            </div>
        </>
    );
};
